import React from "react";

export default function EvaHomeCardSkeleton()
{
    return (
        <div style={cardStyle}>

            {/* Image */}
            <div
                className="eva-skeleton"
                style={imageStyle}
            />

            {/* Icon */}
            <div
                className="eva-skeleton"
                style={iconStyle}
            />

            {/* Content */}
            <div style={contentStyle}>

                <div
                    className="eva-skeleton"
                    style={titleStyle}
                />

                <div
                    className="eva-skeleton"
                    style={descriptionStyle}
                />

                <div
                    className="eva-skeleton"
                    style={descriptionShortStyle}
                />

            </div>

        </div>
    );
}


//============================================================
// Styles
//============================================================

const cardStyle =
{
    position: "relative",
    minWidth: 0,

    background: "#ffffff",

    borderRadius: "14px",

    overflow: "hidden",

    boxShadow:
        "0 8px 28px rgba(31,25,55,0.06)",

    border:
        "1px solid rgba(65,50,100,0.05)"
};


const imageStyle =
{
    width: "100%",
    height: "150px"
};


const iconStyle =
{
    position: "absolute",

    top: "125px",
    left: "22px",

    width: "48px",
    height: "48px",

    borderRadius: "12px",

    border:
        "3px solid #ffffff"
};


const contentStyle =
{
    minHeight: "105px",

    padding:
        "34px 22px 20px 22px"
};


const titleStyle =
{
    width: "42%",
    height: "18px",

    marginBottom: "14px",

    borderRadius: "6px"
};


const descriptionStyle =
{
    width: "88%",
    height: "11px",

    marginBottom: "8px",

    borderRadius: "5px"
};


const descriptionShortStyle =
{
    width: "65%",
    height: "11px",

    borderRadius: "5px"
};